import { render, staticRenderFns } from "./ReportingTag.vue?vue&type=template&id=30f14c24&"
import script from "./ReportingTag.vue?vue&type=script&lang=js&"
export * from "./ReportingTag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports